import Home from './components/Home';
// import Doga from './components/Doga';
// import NewSeason from "@/components/NewSeason.vue";
// import KeyConnect from "@/components/KeyConnect.vue";
import Okyanus from './components/Okyanus';
import NOM from './components/NOM';
import RLP from './components/RLP';
import UESRLPLogin from './components/UESRLPLogin';
import EFS from './components/EFS';
import Maneno from './components/Maneno';
import Sensations from "@/components/Sensations.vue";
import K12Net from "@/components/K12Net.vue";
import K12NetRedirect from "@/components/K12NetRedirect.vue";
import RazPlus from "@/components/RazPlus.vue";
import RazPlusLogin from "@/components/RazPlusLogin.vue";
import Espresso from "@/components/Espresso.vue";
import Kidzwonder from "@/components/Kidzwonder.vue";
import KidzwonderJr from "@/components/KidzwonderJr.vue";
import Kidzwonder3D from "@/components/Kidzwonder3D.vue";
import Hexagonia from "@/components/Hexagonia.vue";
import MyEduClass from "@/components/MyEduClass.vue";
import UESPortals from "@/components/UESPortals.vue";
import HLL from "@/components/HLL.vue";
import SebitVCloud from "@/components/SebitVCloud.vue";
import SebitVCloudBeta from "@/components/SebitVCloudBeta.vue";
import Deutschbesten from "@/components/Deutschbesten.vue";
import FNLEnglish from "@/components/FNLEnglish.vue";
import LanguageMate from "@/components/LanguageMate.vue";
import EnglishPlayBox from "@/components/EnglishPlayBox.vue";
import MyEduAssessment from "@/components/MyEduAssessment.vue";
import RichmondStudio from "@/components/RichmondStudio.vue";
import LGSXXLarge from "@/components/LGSXXLarge.vue";
import SinavReadingMachine from "@/components/SinavReadingMachine.vue";
import MayaEduClass from "@/components/MayaEduClass.vue";
import Gradingly from "@/components/Gradingly.vue";
import Speakia from "@/components/Speakia.vue";
import BoostifyEdu from "@/components/BoostifyEdu.vue";
import BoostifyApp from "@/components/BoostifyApp.vue";

export const routes = [
  { path: '/', component: Home },
  // { path: '/new-season', component: NewSeason, },
  // { path: '/doga', component: Doga, }
  // { path: '/key-connect', component: KeyConnect },
  { path: '/okyanus', component: Okyanus  },
  { path: '/nom', component: NOM },
  { path: '/rlp', component: RLP },
  { path: '/ues-rlp-login', component: UESRLPLogin, },
  { path: '/efs', component: EFS },
  { path: '/maneno', component: Maneno },
  { path: '/sensations', component: Sensations },
  { path: '/k12net', component: K12Net },
  { path: '/raz-plus', component: RazPlus },
  { path: '/raz-plus-login', component: RazPlusLogin },
  { path: '/k12net-redirect', component: K12NetRedirect },
  { path: '/espresso', component: Espresso },
  { path: '/kidzwonder', component: Kidzwonder },
  { path: '/kidzwonder-jr', component: KidzwonderJr },
  { path: '/kidzwonder-3d', component: Kidzwonder3D },
  { path: '/hexagonia', component: Hexagonia },
  { path: '/myeduclass', component: MyEduClass },
  { path: '/uesportals', component: UESPortals },
  { path: '/hll', component: HLL },
  { path: '/sebitvcloud', component: SebitVCloud },
  { path: '/sebitvcloud-beta', component: SebitVCloudBeta },
  { path: '/deutschbesten', component: Deutschbesten },
  { path: '/fnlenglish', component: FNLEnglish },
  { path: '/languagemate', component: LanguageMate },
  { path: '/englishplaybox', component: EnglishPlayBox },
  { path: '/myeduassessment', component: MyEduAssessment },
  { path: '/richmondstudio', component: RichmondStudio },
  { path: '/lgsxxlarge', component: LGSXXLarge },
  { path: '/sinavreadingmachine', component: SinavReadingMachine },
  { path: '/mayaeduclass', component: MayaEduClass },
  { path: '/gradingly', component: Gradingly },
  { path: '/speakia', component: Speakia },
  { path: '/boostifyedu', component: BoostifyEdu },
  // BoostifySpeak / BoostifyWrite / BoostifyExam mobil uygulamalarına deep link ile giriş (bkz. BoostifyApp.vue)
  { path: '/boostifyspeak', component: BoostifyApp, props: { app: 'speak' } },
  { path: '/boostifywrite', component: BoostifyApp, props: { app: 'write' } },
  { path: '/boostifyexam', component: BoostifyApp, props: { app: 'exam' } },
];
